import VideoJsAdapter from "@javascripts/adapters/videojs_adapter";
export default VideoJsAdapter.getComponent('Component');
